import ReactDOM from 'react-dom/client';
import React from 'react';
import { AssignUnitSelect } from './assign-unit-select';
import { DateTime } from 'luxon';
import { TenantContext } from '../../../context/tenant-context';
import { v2Component } from '../../../index';

function initAssignUnitSelect(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('assign-unit-select');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const setRootAttributes = (o: any) => {
        Object.keys(o).forEach((k) => {
          element.setAttribute(k, o[k]);
        });
      };

      const bootstrap = (mutations: MutationRecord[]) => {
        if (
          mutations.length === 0 ||
          mutations.find(
            (r) =>
              r.attributeName === 'data-quantity' ||
              r.attributeName === 'data-is-blocked' ||
              r.attributeName === 'data-location-id',
          )
        ) {
          const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
          const props = {
            ...dataset,
            quantity: parseInt(dataset.quantity),
            startDate: DateTime.fromISO(dataset.startDate, { setZone: true }),
            endDate: DateTime.fromISO(dataset.endDate, { setZone: true }),
            isBlocked: dataset.isBlocked !== '0',
            orderId: dataset.orderId ? parseInt(dataset.orderId) : undefined,
            orderProductId: dataset.orderProductId ? parseInt(dataset.orderProductId) : undefined,
            locationId: parseInt(dataset.locationId),
          };
          root.render(
            v2Component(
              <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
                <AssignUnitSelect {...props} setRootAttributes={setRootAttributes} />
              </TenantContext.Provider>,
            ),
          );
          const event = new CustomEvent('change');
          element.dispatchEvent(event);
        }
      };

      const observer = new MutationObserver(bootstrap);
      observer.observe(element, { attributes: true });
      bootstrap([]);
    }
  });
}

// Adding custom event to render future components on DOM.
declare global {
  interface Window {
    assignUnitEvent: CustomEvent;
  }
}

window.assignUnitEvent =
  window.assignUnitEvent ||
  new CustomEvent('renderAssignUnit', {
    bubbles: true,
    detail: { init: (element: HTMLElement) => initAssignUnitSelect(element) },
  });

export { initAssignUnitSelect };
